import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getSpacing } from '../../util/spacing.js';
import { Direction } from '../../contexts/session/Locale.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  m: '0'
};

// Only needed for IE, newer browsers support textAlign: start/end
var alignTextRtl = {
  start: 'right',
  center: 'center',
  end: 'left'
};
var alignTextLtr = {
  start: 'left',
  center: 'center',
  end: 'right'
};
var getTextAlign = function getTextAlign(direction, textAlign) {
  if (!textAlign) return undefined;
  return direction === Direction.RTL ? alignTextRtl[textAlign] : alignTextLtr[textAlign];
};
var getTypographySpacing = function getTypographySpacing(props, direction, spacingTheme) {
  var hasNonZeroPaddingEnd = props.pe && props.pe !== '0';
  var shouldAddPaddingEnd = !hasNonZeroPaddingEnd && Number.isInteger(props.lineClamp) && props.textAlign === 'end';

  // Add padding end to Typography to work around ellipsis not being visible for end-aligned text
  var propsForSpacing = _objectSpread(_objectSpread({}, props), shouldAddPaddingEnd && {
    pe: '8'
  });
  return getSpacing(propsForSpacing, direction, spacingTheme);
};

export { defaultProps, getTextAlign, getTypographySpacing };
//# sourceMappingURL=Typography.mappers.js.map
